var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{staticStyle:{"color":"#ffffff"},attrs:{"to":{name: 'department', params: {'departmentSlug': _vm.department.slug }}}},[_vm._v("\n    {$department.name}\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }